import { Component, OnInit } from '@angular/core';
import { PagosGeneralesService } from 'src/app/shared/services/pagos-generales.service';
import { CompaniesService } from 'src/app/shared/services/companies.service';
import { Level } from '../../shared/enums/level.enum';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { Payments } from 'src/app/shared/models/payments';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pagos-generales',
  templateUrl: './pagos-generales.component.html',
  styleUrls: ['./pagos-generales.component.scss']
})
export class PagosGeneralesComponent implements OnInit {
   pagos: Payments[];
   _subscriptions: Subscription[] = [];
   usdt: any;
  public filtros: { 
    dateStart: Date, 
    dateEnd: Date,
    companyId: number
  };

  public companies: {id: string, companyName: string}[];

  constructor(
    private utilitiesServices: UtilitiesService,
    private pagosGeneralesService: PagosGeneralesService,
    private companies_service: CompaniesService,
  ) {
    this.usdt = this.utilitiesServices.getUserData();
    switch (this.usdt.level) {
      case Level.ihunterSuperUser:
          this.filtros = {
            dateStart: new Date(),
            dateEnd: new Date(),
            companyId: null
          }
      default:
        break;
    }
   }

  ngOnInit(): void {
    this.getCompanies();
    this.getPagos();
  }


  getCompanies() {
    this.companies_service.getCompanies().subscribe(
      (res: any) => {
        this.companies = res;
        this.companies.unshift({id: '0', companyName: 'Seleccionar Empresa'});
      },
      error => {
        console.log(error);
    });
  }
  
  getPagos(e?){
    this.filtros.dateStart.setHours(0,0,0).toLocaleString();
    this.filtros.dateEnd.setHours(23,59,59).toLocaleString();
    this.pagosGeneralesService.getPagos(this.filtros.dateStart,this.filtros.dateEnd,this.filtros.companyId).subscribe(
      (res: any) => {
          console.log('1 .- ',res);
          console.log('2 .-' , res.data);
          this.pagos = res.data;
    },
    (error) => {
      console.log(error);
    });
  }

}
